import React, { useEffect, useState } from 'react';
import { PHARMACY_LIST } from 'helpers/types';
import { Formik, ErrorMessage } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { validatePostcode } from 'helpers/yupmatchers';
import usePostcodePharmacy from 'hooks/usePostcodePharmacy';
import styles from './style.module.css';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'components';
import jwt_decode from 'jwt-decode';
import { isUserRowlandsInStore } from 'helpers/helperFunctions';

const FindPharmacyByPostcodeFormSchema = Yup.object().shape({
  postcode: validatePostcode,
});

const FindPharmacyByPostcodeForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [postcodesPharmacy, getPostcodePharmacy, errorMessage] = usePostcodePharmacy();
  const values = { postcode: '' };
  const [loading, setLoading] = useState(false);
  const jwt = useSelector((state) => state.auth.authenticated);
  const decodedJwt = jwt_decode(jwt);
  const { paymentJourney: { selectedPharmacyDetails }} = useSelector(state => state);

  const submitForm = async (payload, actions) => {
    try {
      setLoading(true);
      await getPostcodePharmacy(payload.postcode.toUpperCase(), decodedJwt?.user_source === 'heyPharmacist', isUserRowlandsInStore(selectedPharmacyDetails));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      history.push('/pharmacy/error');
    }
  };

  useEffect(() => {
    const pharmacyInfo = (payload) => {
      dispatch({
        type: PHARMACY_LIST,
        payload: payload,
      });
      history.push('/pharmacy/dashboard/find-pharmacy/select');
    };
    if (postcodesPharmacy.length > 0) pharmacyInfo(postcodesPharmacy);
  }, [postcodesPharmacy, dispatch, history]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <Formik
        initialValues={values}
        validationSchema={FindPharmacyByPostcodeFormSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => submitForm(values, actions)}>
        {(props) => (
          <form className={styles.form} onSubmit={props.handleSubmit}>
            <label className={styles.mb0} htmlFor="postcode">
              <h2 className={`coop-t-h3`}>Search for a pharmacy</h2>
              Enter a postcode
              <ErrorMessage
                name="postcode"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              {errorMessage && <p data-testid="error-message" className={`coop-c-form-error__text ${styles.errorText}`}>{errorMessage}</p>}
              <input
                maxLength="255"
                id="postcode"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.postcode}
                className={`coop-form__input ${
                  props.errors.postcode && props.touched.postcode && 'coop-form__invalid'
                }`}
                name="postcode"
              />
            </label>
            <button type="submit" className={`coop-btn coop-btn--primary coop-c-hero__cta ${styles.submit}`}>
              Find a pharmacy
            </button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FindPharmacyByPostcodeForm;
